// removed by extract-text-webpack-plugin
module.exports = {"startingPpoint":"rate-common-addressInformation-startingPpoint","starting":"rate-common-addressInformation-starting","iconTruck":"rate-common-addressInformation-iconTruck","iconUnderline":"rate-common-addressInformation-iconUnderline","line":"rate-common-addressInformation-line","triangle":"rate-common-addressInformation-triangle","point":"rate-common-addressInformation-point","equipment":"rate-common-addressInformation-equipment"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rate/common/addressInformation/index.css
// module id = 1827
// module chunks = 0